import { Artefact } from "@cryptors/api-client";
import ClearIcon from "@mui/icons-material/Clear";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Typography, Box, Divider, IconButton, Stack } from "@mui/material";
import { useGo } from "@refinedev/core";
import { TextFieldComponent as TextField } from "@refinedev/mui";
import { FC } from "react";
import { useParams } from "react-router-dom";

import { getTranslation } from "@/utils/translation";

interface CryptorArtefactShowProps {
  title: string;
  artefact: Artefact | null;
}

const CryptorArtefactShow: FC<CryptorArtefactShowProps> = ({
  title,
  artefact,
}) => {
  const go = useGo();
  const { id } = useParams();
  return (
    <>
      <Divider sx={{ marginTop: 3 }} />
      <Typography variant="body1" fontWeight="bold">
        {title}
      </Typography>
      {artefact ? (
        <Box>
          <Typography variant="body2" fontWeight="bold">
            Titre de la pop-up
          </Typography>
          <TextField
            value={getTranslation(artefact?.titlePopUpTranslation)?.value}
          />
          <Typography variant="body2" fontWeight="bold">
            Texte de la pop-up
          </Typography>
          <TextField
            value={getTranslation(artefact?.textPopUpTranslation)?.value}
          />
          <Typography variant="body2" fontWeight="bold">
            Récompense
          </Typography>
          <TextField value={artefact?.reward} />
          <Typography variant="body2" fontWeight="bold">
            Image
          </Typography>
          <img src={artefact?.image?.url} alt="Badge" width="100" />
          {artefact?.chatMessageId && (
            <Stack
              marginTop={1}
              marginBottom={1}
              direction="row"
              alignItems="center"
            >
              <Typography variant="body1" fontWeight="bold">
                Chat message
              </Typography>
              <IconButton
                onClick={() => {
                  go({
                    to: `/cryptors/${id}/chat-message/${artefact.chatMessageId}`,
                  });
                }}
              >
                <OpenInNewIcon />
              </IconButton>
            </Stack>
          )}
        </Box>
      ) : (
        <ClearIcon />
      )}
    </>
  );
};

export default CryptorArtefactShow;
